<div class="br-caption-2 text-ellipsis"
     ngbTooltip
     [appBringozTooltip]="isHideTooltip ? undefined:  name"
     [ngStyle]="{background: backgroundColor, color: color}">
  <span>{{ name }}</span>
</div>
